import { smartWriterActions } from './smartWriterActions';
import { smartWriterSelectors } from './smartWriterSelectors';
import { smartWriterReducer } from './smartWriterReducer';

export const smartWriter = {
  actions: smartWriterActions,
  reducer: smartWriterReducer,
  selectors: smartWriterSelectors,
};
